<template>
    <div 
        class="layout-external-register defaultTheme"
        :style="{ '--bg-mobile': `url(${backgroundMobileSrc})` }"
    >
        <div class="left">
            <img
                :src="logoSrc"
                class="logo"
                alt="Logo P2U"
            />
            <router-view />
        </div>
        <!-- <div class="right">
            <img
                :src="fundoBordaSrc"
                class="background-desktop"
                alt="Background desktop"
            />
            </div> -->
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import logoSrc from '@/assets/images/logoLogin.svg'
    import fundoBordaSrc from '@/assets/images/fundoBorda.png'
    import backgroundMobileSrc from '@/assets/images/background-external-mobile.png'

    export default defineComponent({
        name: 'LayoutRegistro',
        setup() {
            return {
                logoSrc,
                fundoBordaSrc,
                backgroundMobileSrc,
            }
        },
    })
</script>

<style lang="scss">
    .layout-external-register {
        display: flex;
        flex-direction: column;
        // min-height: 100vh;
        width: 100%;
        user-select: none;
        // overflow-x: hidden;
        
        @include desktop {
            width: 100%;
            height: 100vh;
            // min-height: auto;
            flex-direction: row;
            background-color: #F7FAFE;
        }
        
        .left {
            display: flex;
            flex-direction: column;
            align-items: start;
            margin: 0 auto;
            width: 100%;
            padding: 2.5rem;
            z-index: 2;

            @include desktop {
                width: 81rem;
                height: fit-content;
                margin: auto auto auto auto;
                background-color: #FFFFFF;
                box-shadow: 0 0 1rem 0.1rem #00000020;
                border-radius: 0.9375rem;
                
            }

            .logo {
                height: 3.625rem;
                max-width: 100%;
                margin: 1.8rem auto;

                @include desktop {
                    margin: 0;
                }
            }

            @include desktop {
                &::-webkit-scrollbar {
                    width: 0px;
                    background: transparent;
                }
            }
        }
    }
</style>